import React from "react";
import { If } from "./control-statements/If";

import { Button } from "./Button";
import { Drawer } from "./Drawer";
import styles from '../../styles/alert.module.scss'

export class Alert extends React.Component {

    state = {
        type: 'alert',
        msg: "",
        buttonText: 'Ok',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Voltar',
        onConfirmResolve: null
    }

    constructor(props) {
        super(props);
        window.confirm = this.showConfirm.bind(this)
        window.alert = this.showAlert.bind(this)
    }

    async setAsyncState(data) {
        return await new Promise(resolve => this.setState(data, resolve));
    }

    async showConfirm({ text, confirmText, cancelText }) {

        await this.setAsyncState({
            type: 'confirm',
            msg: text,
            visible: true,
            confirmButtonText: confirmText || "Sim",
            cancelButtonText: cancelText || "Voltar"

        });

        return new Promise((resolve) => {
            this.setState({ onConfirmResolve: resolve });
        })
    }

    async showAlert({ text, buttonText, secondsToClose = null }) {
        await this.setAsyncState({
            type: 'alert',
            msg: text,
            visible: true,
            buttonText: buttonText || "Confirmar"
        });

        if (Number(secondsToClose) > 0) {
            return new Promise(async (resolve) => {
                const clearId = setTimeout(() => {
                    this.setState({ visible: false });
                    resolve(true)
                }, secondsToClose * 1000)

                await this.setAsyncState({
                    onConfirmResolve: (response) => {
                        clearId && clearTimeout(clearId);
                        this.setState({ visible: false });
                        resolve(response)
                    }
                });

            });
        } else {
            return new Promise((resolve) => {
                this.setState({ onConfirmResolve: resolve });
            })
        }
    }

    onConfirmClick(response) {
        const { onConfirmResolve } = this.state;
        this.setState({ visible: false });
        onConfirmResolve && onConfirmResolve(response);
    }

    render() {

        const { msg, type, buttonText, confirmButtonText, cancelButtonText, visible } = this.state;

        if (!visible) return null;

        return (
            <Drawer
                visible={visible}
                title='Atenção'
                direction='top-alert'
                alert
                onClose={() => this.onConfirmClick(false)}
            >
                <div className={styles.alert}>
                    <p>{msg}</p>
                    <If cond={type === 'alert'}>
                        <Button design="primary" onClick={() => this.onConfirmClick(true)} >
                            {buttonText}
                        </Button>
                    </If>
                    <If cond={type === 'confirm'}>
                        <div className={styles.confirm}>
                            <Button onClick={() => this.onConfirmClick(true)} className={styles.yes} design="primary">
                                {confirmButtonText}
                            </Button>
                            <Button onClick={() => this.onConfirmClick(false)} className={styles.no}>
                                {cancelButtonText}
                            </Button>
                        </div>
                    </If>
                </div>
            </Drawer>
        )
    }
}